import { Component, ViewEncapsulation, OnInit, ViewChild, ElementRef } from '@angular/core';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { KYMW5900Model } from './kymw5900.model';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { GetCwsPlanGoodsListService } from './api-services/get-cws-plan-goods-list.service';
import { FileDownloadConfirmService } from '../../../commons/kymw02/file-download-confirm/file-download-confirm.service';
import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';

/**
 * EC企画商品一覧表画面を管理するクラス
 *
 * @export KYMW5900Component
 * @class KYMW5900Component
 */
@Component({
  selector: 'app-kymw5900',
  templateUrl: 'kymw5900.component.html',
  styleUrls: ['kymw5900.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW5900Component extends PlessViewHelperSub implements OnInit {

  // 親画面からの連携値
  param: any;

  kymw5900Model: KYMW5900Model = new KYMW5900Model();

  /** 生協コードマスタ */
  public coopData: Array<any> = null;

  public CHECK_ON = '1';

  @ViewChild('lbl_DelivCatalog', { static: true }) lbl_DelivCatalog: HTMLInputElement;

  /**
   *Creates an instance of KYMW5900Component.
   * @param {PlessDialogServiceSub} dialogService
   * @param {KYMW00Model} kymw00Model
   * @param {GetCwsPlanGoodsListService} getCwsPlanGoodsListService
   * @param {FileDownloadConfirmService} fileDownloadConfirmService
   * @memberof KYMW5900Component
   */
  constructor(
    public dialogService: PlessDialogServiceSub,
    public kymw00Model: KYMW00Model,
    public elementRef: ElementRef,
    public getCwsPlanGoodsListService: GetCwsPlanGoodsListService,
    public fileDownloadConfirmService: FileDownloadConfirmService
  ) {
    super(kymw00Model);
  }

  /**
   * 初期処理
   *
   * @memberof PhaseRegistComponent
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW5900';

    // 生協コード値のマップ
    this.coopData = [];
    this.coopData['chk_Ibaraki'] = this.kymw00Model.COOP_CODE_IB;
    this.coopData['chk_Tochigi'] = this.kymw00Model.COOP_CODE_TO;
    this.coopData['chk_Gunma'] = this.kymw00Model.COOP_CODE_GU;
    this.coopData['chk_Chiba'] = this.kymw00Model.COOP_CODE_TI;
    this.coopData['chk_Saitama'] = this.kymw00Model.COOP_CODE_SA;
    this.coopData['chk_Tokyo'] = this.kymw00Model.COOP_CODE_TK;
    this.coopData['chk_Nagano'] = this.kymw00Model.COOP_CODE_NA;
    this.coopData['chk_Niigata'] = this.kymw00Model.COOP_CODE_NI;

    this.initKYMW5900();
  }

  /**
	 * 出力ボタンを押下した時に呼び出されるメソッド。
	 *
	 * @param event コールバック・イベントへの参照
	 */
  public eventCSVOut_CLICKHandler(lbl_DelivCatalog: HTMLInputElement): void {
    // 入力チェック
    if (this.inputCheck(lbl_DelivCatalog) === false) {
      return;
    }

    const vo = {
      /** 受注コード */
      orderCode: '',
      /** 部門コード */
      classCode: '',
      /** 媒体区分 */
      mediumType: '',
      /** 登録商品区分 */
      entryGoodsDiv: '',
      /** 生協コード */
      coopCodeList: []
    };
    // VO設定
    vo.orderCode = this.kymw5900Model.orderCode;
    vo.classCode = PlessViewUtilsSub.nullToBlank(this.kymw5900Model.classCode);
    vo.mediumType = PlessViewUtilsSub.nullToBlank(this.kymw5900Model.mediumType);

    vo.entryGoodsDiv = PlessViewUtilsSub.nullToBlank(this.kymw5900Model.entryGoodsDiv);
    vo.coopCodeList = [];
    if (this.kymw5900Model.ibaraki) {
      vo.coopCodeList.push(this.coopData['chk_Ibaraki']);
    }
    if (this.kymw5900Model.tochigi) {
      vo.coopCodeList.push(this.coopData['chk_Tochigi']);
    }
    if (this.kymw5900Model.gunma) {
      vo.coopCodeList.push(this.coopData['chk_Gunma']);
    }
    if (this.kymw5900Model.chiba) {
      vo.coopCodeList.push(this.coopData['chk_Chiba']);
    }
    if (this.kymw5900Model.saitama) {
      vo.coopCodeList.push(this.coopData['chk_Saitama']);
    }
    if (this.kymw5900Model.tokyo) {
      vo.coopCodeList.push(this.coopData['chk_Tokyo']);
    }
    if (this.kymw5900Model.nagano) {
      vo.coopCodeList.push(this.coopData['chk_Nagano']);
    }
    if (this.kymw5900Model.niigata) {
      vo.coopCodeList.push(this.coopData['chk_Niigata']);
    }

    // API呼び出し
    this.getCwsPlanGoodsListService.execute(this.kymw5900Model, vo, (data: any) => {
      // ファイル名の設定
      const fileName = 'EC企画商品一覧表_' + PlessViewUtilsSub.formatedNowDate('YYYYMMDD_hhmmss') + '.tsv';
      this.fileDownloadConfirmService.show(data.FileName, fileName);
    });
  }

  /**
  *  画面情報の初期化
  */
  public initKYMW5900(): void {
    // 受注コードをクリアに連動して、配達企画回（翌週）がクリア、媒体が再作成される。
    this.kymw5900Model.orderCode = '';
    // 会員生協
    this.kymw5900Model.allCoop = true;
    this.kymw5900Model.ibaraki = true;
    this.kymw5900Model.tochigi = true;
    this.kymw5900Model.gunma = true;
    this.kymw5900Model.chiba = true;
    this.kymw5900Model.saitama = true;
    this.kymw5900Model.tokyo = true;
    this.kymw5900Model.nagano = true;
    this.kymw5900Model.niigata = true;
  }

  /**
   * メニュー「最新の情報に更新」押下時の処理
   *
   */
  public reloadKYMW5900(): void {
    this.initKYMW5900();
  }

  /**
   * 入力チェック
   *
   * @return true:OK false:NG
   */
  private inputCheck(lbl_DelivCatalog: HTMLInputElement): boolean {
    // 受注コード必須チェック
    if (PlessViewUtilsSub.isEmpty(this.kymw5900Model.orderCode)) {
      this.dialogService.openAlertGetMessage('E0110', ['受注コード']);
      return false;
    }
    // 受注コード存在チェック
    if (PlessViewUtilsSub.isEmpty(lbl_DelivCatalog.value)) {
      this.dialogService.openAlertGetMessage('E0122', ['受注コード']);
      return false;
    }
    // 部門
    const classCode: string = PlessViewUtilsSub.nullToBlank(this.kymw5900Model.mediumType);
    // 媒体
    const mediumType: string = PlessViewUtilsSub.nullToBlank(this.kymw5900Model.mediumType);
    // 登録商品
    const entryGoodsDiv: string = PlessViewUtilsSub.nullToBlank(this.kymw5900Model.entryGoodsDiv);
    // 会員生協
    if (!this.kymw5900Model.ibaraki &&
      !this.kymw5900Model.tochigi &&
      !this.kymw5900Model.gunma &&
      !this.kymw5900Model.chiba &&
      !this.kymw5900Model.saitama &&
      !this.kymw5900Model.tokyo &&
      !this.kymw5900Model.nagano &&
      !this.kymw5900Model.niigata) {
      this.dialogService.openAlertGetMessage('E0103', ['会員生協']);
      return false;
    }
    return true;
  }

  /**
   * 全生協選択の処理
   *
   */
  public eventAllCoop_CHANGEHandler(): void {
    this.kymw5900Model.ibaraki = this.kymw5900Model.allCoop;
    this.kymw5900Model.tochigi = this.kymw5900Model.allCoop;
    this.kymw5900Model.gunma = this.kymw5900Model.allCoop;
    this.kymw5900Model.chiba = this.kymw5900Model.allCoop;
    this.kymw5900Model.saitama = this.kymw5900Model.allCoop;
    this.kymw5900Model.tokyo = this.kymw5900Model.allCoop;
    this.kymw5900Model.nagano = this.kymw5900Model.allCoop;
    this.kymw5900Model.niigata = this.kymw5900Model.allCoop;
  }

  /**
   * 生協のチェックを変更したときのイベント処理
   */
  public eventSeikyou_CLICKHandler() {
    const seikyouCheckboxTarget = [
      this.kymw5900Model.ibaraki,
      this.kymw5900Model.tochigi,
      this.kymw5900Model.gunma,
      this.kymw5900Model.chiba,
      this.kymw5900Model.saitama,
      this.kymw5900Model.tokyo,
      this.kymw5900Model.nagano,
      this.kymw5900Model.niigata,
    ];
    // チェックされた生協のチェックボックスを格納
    const seikyouCheckedTarget = seikyouCheckboxTarget.filter(
      checked => checked
    );

    // チェックされた生協の数が全生協の数と一致しているか（一致：「ALL」をチェック、不一致：「ALL」からチェックを外す）
    if (seikyouCheckedTarget.length === seikyouCheckboxTarget.length) {
      this.kymw5900Model.allCoop = true;
    } else {
      this.kymw5900Model.allCoop = false;
    }
  }
}
